import React from "react";
import "../styles/DocumentarySection.css";
import { FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// ✅ Import PDFs
import OfficeNotice from "../Assets/Pdfs/office notice.pdf";
import AdmissionInfo2025 from "../Assets/Pdfs/Admission Notice for 2026.pdf";
import FinalFormFillupNine from "../Assets/Pdfs/Final form fillup for class Nine.pdf";


// ✅ Import Videos
import Video1 from "../Assets/Videos/VID_20231109_144925.mp4";
import Video2 from "../Assets/Videos/Official Video.mp4";
import Video3 from "../Assets/Videos/My Video.mp4";

// ✅ Documentary List (local videos)
const documentaries = [
  {
    id: 1,
    title: "Official Documentary 1",
    subtitle: "VID_20231109_144925",
    video: Video1,
  },
  {
    id: 2,
    title: "Official Documentary 2",
    subtitle: "Official Video",
    video: Video2,
  },
  {
    id: 3,
    title: "Official Documentary 3",
    subtitle: "My Video",
    video: Video3,
  },
];

// ✅ Notices (with PDFs)
const notices = [
  { id: 1, title: "অফিস বিজ্ঞপ্তি", pdf: OfficeNotice },
  { id: 2, title: "২০২৬ শিক্ষাবর্ষে ভর্তি সংক্রান্ত বিজ্ঞপ্তি", pdf: AdmissionInfo2025 },
  { id: 3, title: "বাংলাদেশ কারিগরি শিক্ষা বোর্ডে নবম শ্রেণীর চূড়ান্ত ফরম ফিলাপ প্রসঙ্গে", pdf: FinalFormFillupNine },
  { id: 4, title: "২০২৫ শিক্ষাবর্ষে ভর্তি সংক্রান্ত বিজ্ঞপ্তি", pdf: AdmissionInfo2025 },
];

export default function DocumentarySection() {
  const navigate = useNavigate();

  const handleMoreClick = () => {
    navigate("/notice");
  };

  const handleVideoClick = () => {
    navigate("/gallery/videos");
  };

  return (
    <section className="doc-notice-section">
      <div className="doc-notice-container">
        {/* ✅ Left: Documentary Section */}
        <div className="documentary-container">
          <h2>Technical Training Center Documentary</h2>

          <div className="documentary-grid">
            {documentaries.map((doc) => (
              <div
                key={doc.id}
                className="documentary-card"
                onClick={handleVideoClick}
                style={{ cursor: "pointer" }}
              >
                <div className="documentary-thumbnail">
                  <video
                    src={doc.video}
                    muted
                    autoPlay
                    loop
                    playsInline
                    poster={doc.poster}
                    className="documentary-video"
                  />
                </div>
                <div className="documentary-content">
                  <h3>{doc.title}</h3>
                  <p>{doc.subtitle}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="documentary-more">
            <button onClick={() => navigate("/gallery/videos")}>More</button>
          </div>
        </div>

        {/* ✅ Right: Notices Section */}
        <aside className="notice-wrapper" aria-labelledby="notice-title">
          <div className="notice-header">
            <h2 id="notice-title">Notices:</h2>
          </div>

          <div className="notice-grid">
            {notices.map((notice) => (
              <div key={notice.id} className="notice-card">
                <a
                  href={notice.pdf}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="notice-title-link"
                >
                  {notice.title}
                </a>

                <div className="notice-icons">
                  <a href={notice.pdf} download>
                    <FaFilePdf className="pdf-btn" title="Download PDF" />
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div className="notice-more">
            <button onClick={handleMoreClick}>More</button>
          </div>
        </aside>
      </div>
    </section>
  );
}
